export function NotificationIcon({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <g id="Group_24486" data-name="Group 24486" transform="translate(-865 -172)">
        <g
          id="Rectangle_10299"
          data-name="Rectangle 10299"
          transform="translate(865 172)"
          fill="#fff"
          stroke="currentColor"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="24" height="24" stroke="none" />
          <rect x="0.5" y="0.5" width="23" height="23" fill="none" />
        </g>
        <path
          id="Path_50066"
          data-name="Path 50066"
          d="M1620.783,2311h-3.547m7.094-11.631a5.365,5.365,0,0,0-1.561-3.794,5.275,5.275,0,0,0-7.519,0,5.365,5.365,0,0,0-1.561,3.794,11.071,11.071,0,0,1-1.463,5.914,8.467,8.467,0,0,0-.967,1.727.368.368,0,0,0,.177.322,5.877,5.877,0,0,0,1.711.09h11.723a5.876,5.876,0,0,0,1.711-.09.367.367,0,0,0,.177-.322,8.444,8.444,0,0,0-.966-1.727A11.069,11.069,0,0,1,1624.33,2299.368Z"
          transform="translate(-742.51 -2118.5)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.6"
        />
      </g>
    </svg>
  );
}
